export { default as Catalog } from './containers/CatalogContainer'



// WEBPACK FOOTER //
// ./src/Catalog/index.js